module.exports = __webpack_public_path__ + "img/close-icon.b0200bf7.svg";